import { createEvent, restore, sample } from 'effector'
import {
  GeneralBalanceFilter,
  PaymentSystem,
  PaymentSystemResponse,
} from './types'
import { fx } from '../../../../../libs'

export const paymentSystemsMounted = createEvent()

export const setGeneralBalanceFilter = createEvent<GeneralBalanceFilter>()

export const $generateBalanceFilter = restore(setGeneralBalanceFilter, {
  countries: [],
  date: {
    dateFrom: '',
    dateTo: '',
  },
})

export const getPaymentSystems = fx<void, PaymentSystemResponse>({
  method: 'GET',
  url: `/finance/payment_system`,
})

export const $paymentSystems = restore<PaymentSystem[]>(
  getPaymentSystems.doneData.map((a) => [
    {
      id: 0,
      name: 'In progress',
      overallBalanceUsd: 0,
      lossPercentage: 0,
      depositAmountUsd: 0,
      withdrawalAmountUsd: 0,
      timezone: '',
      depositTimezone: '',
    },
    ...a.body.items,
  ]),
  [],
)

sample({
  clock: paymentSystemsMounted,
  fn: () => ({
    query: { where: JSON.stringify({ includeArchived: true }), order: 'name' },
  }),
  target: getPaymentSystems,
})
